__turbopack_context__.v({
  "active": "selectAutocompliteAddress-module__r1cI0q__active",
  "autocompleteContainer": "selectAutocompliteAddress-module__r1cI0q__autocompleteContainer",
  "autocompleteInput": "selectAutocompliteAddress-module__r1cI0q__autocompleteInput",
  "border": "selectAutocompliteAddress-module__r1cI0q__border",
  "error": "selectAutocompliteAddress-module__r1cI0q__error",
  "indicatorSeparator": "selectAutocompliteAddress-module__r1cI0q__indicatorSeparator",
  "indicatorsContainer": "selectAutocompliteAddress-module__r1cI0q__indicatorsContainer",
  "input": "selectAutocompliteAddress-module__r1cI0q__input",
  "lk": "selectAutocompliteAddress-module__r1cI0q__lk",
  "menu": "selectAutocompliteAddress-module__r1cI0q__menu",
  "openMenu": "selectAutocompliteAddress-module__r1cI0q__openMenu",
  "option": "selectAutocompliteAddress-module__r1cI0q__option",
  "placeholder": "selectAutocompliteAddress-module__r1cI0q__placeholder",
  "rotateIndicator": "selectAutocompliteAddress-module__r1cI0q__rotateIndicator",
  "selectSimpleControl": "selectAutocompliteAddress-module__r1cI0q__selectSimpleControl",
  "suggestionItem": "selectAutocompliteAddress-module__r1cI0q__suggestionItem",
  "suggestions": "selectAutocompliteAddress-module__r1cI0q__suggestions",
  "valueContainer": "selectAutocompliteAddress-module__r1cI0q__valueContainer",
});
